export default __webpack_public_path__ + "static/media/OROPRETO.81b51c7a.jpeg";